import { AppElement, html } from '../AppElement.js';
import {OPTION_30_DAYS} from "../dateSelect/StayDateRangeSelect";

export default class PageBufferSingle extends AppElement {
    static get properties() {
        return {
            hotel: {type: Object},
            recordDate: {type: String},
            pickupSetting: {type: Number},

            // @internalProperty
            rangeValue: { attribute: false },
            startDate: {attribute: false},
            endDate: {attribute: false},
        };
    }

    constructor(props = {}) {
        super();
        this.hotel = props.hotel || this.hotel || window.infinito.vao.controller.storageHelper.getSelectedHotel();
        this.recordDate = props.recordDate
            || this.recordDate
            || window.infinito.vao.controller.storageHelper.getCurrentDate();
        this.pickupSetting = $.isNumeric(props.pickupSetting)
            ? props.pickupSetting
            : ($.isNumeric(this.pickupSetting)
                    ? this.pickupSetting
                    : window.infinito.vao.controller.storageHelper.getPickupOffset()
            );

        this.rangeValue = OPTION_30_DAYS;
        this.startDate = props.startDate || this.recordDate;
        this.endDate = props.endDate
            || window.infinito.vao.controller.dateHelper.addDaysToDateString(this.startDate, 30);
    }

    reflow(props = {}) {
        this.hotel = props.hotel || this.hotel;
        this.recordDate = props.recordDate || this.recordDate;
        this.pickupSetting = $.isNumeric(props.pickupSetting) ? props.pickupSetting : this.pickupSetting;
    }

    onChangeStayDateRange(e) {
        this.rangeValue = e.detail.newValue;
        this.startDate = e.detail.rangeData.startDate;
        this.endDate = e.detail.rangeData.endDate;
    }

    onFlashButtonClick(){
        let body = '<vao-page-flash-modal></vao-page-flash-modal>';

        let $title =  $('<div></div>').append(
            `<h5>Flash</h5>`
        );
        window.infinito.components.basicModal.render({
            title: $title,
            isTitleHtml: true,
            bodyElem: $(body),
            size:'lg'
        });
    }

    onMonthlyButtonClick(){
        let body =  '<input type="hidden" id="hid" value="'+this.hotel.id+'" />' +
            '<input type="hidden" id="hname" value="'+this.hotel.name+'" />' +
            '<vao-page-monthlyanalysis-modal></vao-page-monthlyanalysis-modal>';

        let $title =  $('<div></div>').append(
            `<h5>Monthly Analysis</h5>`
        );
        window.infinito.components.basicModal.render({
            title: $title,
            isTitleHtml: true,
            bodyElem: $(body),
            size:'xl'
        });
    }

    render() {
        return html`
<div class="vao__components--pageDesktopSingle">
    <div class="rounded border bg-white">
        <div 
            class="vao__components--pageDesktopSingle-filters" 
            style="display:flex;align-items:center;flex-wrap:wrap;padding: 0rem 1rem 0 1rem;"
        >
            <span style="margin-right:15px;margin-top: 15px;">
                <vao-stay-date-range-select
                        .recordDate=${this.recordDate}
                        .value=${this.rangeValue}
                        @vao-stay-date-range-select-change="${this.onChangeStayDateRange}"
                ></vao-stay-date-range-select>
            </span>
           
        </div>
        <hr>
        <div style="margin-top:.5rem;">
            <vao-page-page-buffer
                .hotel="${this.hotel}"
                .recordDate="${this.recordDate}"
                .pickupSetting="${this.pickupSetting}"
                startDate="${this.startDate}"
                endDate="${this.endDate}"
            ></vao-page-page-buffer>
        </div>
    </div>
</div>
        `;
    }
}

window.vao = window.vao || {};
window.vao.components = window.vao.components || {};
window.vao.components.PageBufferSingle = PageBufferSingle;
customElements.define('vao-page-buffer-single', PageBufferSingle);
